import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

// Note the theme keys are the _values_ in this enum.
export enum ThemeKeys {
  blue = 'blue',
  green = 'green',
  darkBlue = 'dark-blue',
  lightGreen = 'light-green',
  orange = 'orange',
  darkOrange = 'dark-orange',
  purple = 'purple',
  red = 'red',
  black = 'black',
  default = 'default',
  pink = 'pink',
  specialBlue = 'special-blue',
  specialPurple = 'special-purple',
  specialRed = 'special-red',
  specialGreen = 'special-green',
}

/**
 * Provide a subscription type, get back a theme key. This theme key can be used to make color-based UI decisions in JS.
 *
 * subscriptionTypeToThemeKey("reading") -> "blue"
 * subscriptionTypeToThemeKey("maths") -> "green"
 */
export function subscriptionTypeToThemeKey(subscriptionType?: SubscriptionType) {
  switch (subscriptionType) {
    case SubscriptionType.Reading:
      return ThemeKeys.blue
    case SubscriptionType.Maths:
      return ThemeKeys.green
    case SubscriptionType.Writing:
      return ThemeKeys.darkBlue
    default:
      return ThemeKeys.default
  }
}

/**
 * Type guard function to narrow type to ThemeKey
 */
export function isThemeKey(maybeThemeKey: unknown): maybeThemeKey is ThemeKeys {
  return Object.values(ThemeKeys).includes(maybeThemeKey as ThemeKeys)
}
